<template>
  <div>           
    <div v-if="type=='ok' || type=='word'">
      <a class="grey-text">Ваш ответ :</a>
      <br />
      <span
        v-for="(satzDeAnswerWord, index) of satzDeAnswerWords"
        v-bind:key="'A_'+index+'_'+satzDeAnswerWord"
      >
        <span
          class="fontbig"
          v-bind:class="formatWord(verify_result.resultWordsAnswerPerson[index])"
        >{{satzDeAnswerWord}}&nbsp;</span>
      </span>
      <br />
    </div>

    <div v-if="type=='word'">
      <a class="grey-text">Правильный ответ:</a>
      <br />
      <span v-for="(satzDeRightWord, index) of satzDeRightWords" v-bind:key="'R_'+index+'_'+satzDeRightWord">
        <span
          class="fontbig"
          v-bind:class="formatWord(verify_result.resultWordsAnswerRight[index], verify_result.resultVerbsPlaceAnswerRight[index] )"
        >{{satzDeRightWord}}&nbsp;</span>
      </span>

      <ul class="collapsible z-depth-0 bordernull" ref="ref_collapsible1">
        <li>
          <div class="collapsible-header bordernull darstellung grey-text">
            <i v-if="!collapsible1_opened" class="material-icons left">expand_more</i>
            <i v-else class="material-icons">expand_less</i>
            обозначения
          </div>
          <div class="collapsible-body bordernull darstellung">
            <span style="color:#ADA20C">ошибка в заглавной букве существительного</span>
            <br />
            <span style="color:#0000CD">ошибка в грамматической форме слова</span>
            <br />
            <span style="color:#800080">ошибка в слове</span>
            <br />
            <span style="color:#FF0000">отсутствует или неизвестное или лишнее слово</span>
            <br />
            <span style="color:#000000" class="unterstreicht">неправильное место глагола</span>
          </div>
        </li>
      </ul>
    </div>

    <h6 class="indigo-text">{{textMsg}}</h6>

    <div v-if="type=='verb'">
      <div v-for="(verb,index) of verify_result.verbsUnknown" v-bind:key="'V_'+index+'_'+verb">{{verb}}</div>
    </div>
  </div>
</template>

<style scoped>
.fontbold {
  font-weight: bold;
}
.fontbig {
  font-size: 150%;
}

.unterstreicht {
  border-bottom: 1px dashed #ff0000;
}

.wordResult_1 {
  color: black;
}
.wordResult_b {
  color: #ada20c;
}
.wordResult_f {
  color: #0000cd;
}
.wordResult_w {
  color: #800080;
}
.wordResult_0 {
  color: #ff0000;
}

.darstellung {
  font-size: 9pt;
}

.bordernull {
  border: 0;
  padding: 0 0 0 0;
}
</style>

<script>
export default {
  name: "verify_result",
  props: ["satzDeAnswer","textMsg", "type"],
  data: () => ({    
    collapsible1: null,
    collapsible1_opened: false
  }),
  computed: {
    satz() {
      return this.$store.getters.satz;
    },
    verify_result() {
      return this.$store.getters.verify_result;
    },
    satzDeAnswerWords() {
      return this.satzDeAnswer.split(" ");
    },
    satzDeRightWords() {
      return this.satz.satzDE.split(" ");
    },    
  },
  mounted() {
    const opts = {
      onOpenEnd: () => {
        this.collapsible1_opened = true;
      },
      onCloseEnd: () => {
        this.collapsible1_opened = false;
      }
    };
    // eslint-disable-next-line no-undef
    this.collapsible1 = M.Collapsible.init(this.$refs.ref_collapsible1, opts);
  },
  beforeDestroy() {
    if (this.collapsible1 && this.collapsible1.destroy) {
      this.collapsible1.destroy();
    }
  },
  methods: {
    formatWord(resultWord, resultVerb) {
      let classFormat = "wordResult_" + resultWord;
      if (resultVerb == "0") {
        classFormat = classFormat + " unterstreicht";
      }
      return classFormat;
    }
  },
  components: {}
};
</script>
